import { render, staticRenderFns } from "./jobseeker-navigation.vue?vue&type=template&id=2497a688"
import script from "./jobseeker-navigation.vue?vue&type=script&lang=js"
export * from "./jobseeker-navigation.vue?vue&type=script&lang=js"
import style0 from "./jobseeker-navigation.vue?vue&type=style&index=0&id=2497a688&prod&style=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports